import * as cold from '@owl-nest/cold-data'

const distributedBrands = Object.values(cold.brands).filter((brand) => brand.isDistributed)

export const brandsStartingWithNumber = distributedBrands.filter((brand) => /^\d/.test(brand.name))

const brandsStartingWithLetter = distributedBrands.filter((brand) => !brandsStartingWithNumber.includes(brand))

const groupedBrands = brandsStartingWithLetter.reduce(
  (groups, brand) => {
    const firstLetter = brand.name.charAt(0).toUpperCase()
    const normalizedFirstLetter = firstLetter.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    if (!groups[normalizedFirstLetter]) {
      groups[normalizedFirstLetter] = []
    }
    groups[normalizedFirstLetter].push(brand)
    return groups
  },
  {} as Record<string, typeof distributedBrands>,
)

export const brandGroups = Object.entries(groupedBrands)
  .map(([key, value]) => ({ key, value }))
  .sort((a, b) => a.value[0].name.localeCompare(b.value[0].name))
